/**
* This file is part of the Haiman.
* @link     : https://haiman.io/
* @author   : Emil Zhai (root@derzh.com)
* @modifier : Emil Zhai (root@derzh.com)
* @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
*/

import metaModule, { StoreSecretTopsMetaState } from './meta';
import detailModule, { StoreSecretTopsDetailState } from './detail';

export interface StoreSecretTopsState {
  meta: StoreSecretTopsMetaState;
  detail: StoreSecretTopsDetailState;
}

export default {
  namespaced: true,
  modules: {
    meta: metaModule,
    detail: detailModule,
  },
  state: {},
  getters: {},
  actions: {},
  mutations: {},
};
